'use client';
/** @jsxImportSource @emotion/react */

import type { DateRangePickerProps as MuiDateRangePickerProps } from '@mui/x-date-pickers-pro/DateRangePicker';

import { type PickerValidDate } from '@mui/x-date-pickers-pro';
import { DateRangePicker as MuiDateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';

type ExcludedMuiProps =
  | 'calendars'
  | 'currentMonthCalendarPosition'
  | 'dayOfWeekFormatter'
  | 'defaultRangePosition'
  | 'disableAutoMonthSwitching'
  | 'disableHighlightToday'
  | 'displayWeekNumber'
  | 'enableAccessibleFieldDOMStructure'
  | 'fixedWeekNumber'
  | 'formatDensity'
  | 'inputRef'
  | 'label'
  | 'name'
  | 'onSelectedSectionsChange'
  | 'reduceAnimations'
  | 'referenceDate'
  // The following props are ignored in DateRangePicker so they can be excluded
  | 'selectedSections'
  | 'showDaysOutsideCurrentMonth'
  | 'viewRenderers';

type DateRangePickerProps<TDate extends PickerValidDate> = Omit<
  MuiDateRangePickerProps<TDate, false>,
  ExcludedMuiProps
>;

export type { DateRangePickerProps };

export function DateRangePicker<TDate extends PickerValidDate>(
  props: DateRangePickerProps<TDate>
) {
  return (
    <MuiDateRangePicker
      {...props}
      slotProps={{
        ...props.slotProps,
        fieldRoot: {
          alignItems: 'baseline',
          ...props.slotProps?.fieldRoot,
        },
      }}
      calendars={2}
      enableAccessibleFieldDOMStructure={false}
    />
  );
}
